import type { ForYouItem, HomeSettings, Meditation } from "@/types";
import type { ServiceResponse } from "./api.types";
import { privateAPI } from "./axios";

export interface ForYouItemPayload {
  eyebrow?: string | null;
  title: string;
  link: string;
  position?: number;
  is_published?: boolean;
  image_extension?: string | null;
}

export const getForYouItems = async (): Promise<
  ServiceResponse<ForYouItem[]>
> => {
  const response =
    await privateAPI.get<ServiceResponse<ForYouItem[]>>("/home/for-you");
  return response.data;
};

export const createForYouItem = async (
  payload: ForYouItemPayload,
): Promise<ServiceResponse<ForYouItem>> => {
  const response = await privateAPI.post<ServiceResponse<ForYouItem>>(
    "/home/for-you",
    payload,
  );
  return response.data;
};

export const updateForYouItem = async ({
  id,
  payload,
}: {
  id: string;
  payload: ForYouItemPayload;
}): Promise<ServiceResponse<ForYouItem>> => {
  const response = await privateAPI.put<ServiceResponse<ForYouItem>>(
    `/home/for-you/${id}`,
    payload,
  );
  return response.data;
};

export const deleteForYouItem = async (id: string): Promise<void> => {
  await privateAPI.delete(`/home/for-you/${id}`);
};

export const getForYouItemImageUploadEndpoint = (id: string): string =>
  `/home/for-you/${id}/image/upload-url`;

export const getHomeSettings = async (): Promise<
  ServiceResponse<HomeSettings>
> => {
  const response =
    await privateAPI.get<ServiceResponse<HomeSettings>>("/home/settings");
  return response.data;
};

export const updateHomeSettings = async (
  featuredMeditationId: string | null,
): Promise<ServiceResponse<HomeSettings>> => {
  const response = await privateAPI.put<ServiceResponse<HomeSettings>>(
    "/home/settings",
    {
      featured_meditation_id: featuredMeditationId,
    },
  );
  return response.data;
};

export const getWeeklyMeditations = async (
  curatedOnly = false,
): Promise<ServiceResponse<Meditation[]>> => {
  const response = await privateAPI.get<ServiceResponse<Meditation[]>>(
    `/home/weekly-meditations${curatedOnly ? "?curated=1" : ""}`,
  );
  return response.data;
};

export const updateWeeklyMeditations = async (
  meditationIds: string[],
): Promise<ServiceResponse<HomeSettings>> => {
  const response = await privateAPI.put<ServiceResponse<HomeSettings>>(
    "/home/weekly-meditations",
    { meditation_ids: meditationIds },
  );
  return response.data;
};
